<template>
  <v-content>

    <im-prg-bar/>
    <im-app-bar/>
    <im-nav-bar/>

    <router-view :key="$route.fullPath"/>

  </v-content>
</template>

<script>
  export default {
    components: {
      'im-prg-bar': () => import('@/components/TheProgressBar'),
      'im-app-bar': () => import('@/components/TheAppBar'),
      'im-nav-bar': () => import('@/components/TheNavBar')
    }
  }
</script>